export const mockGTINCard = {
    package_type: 'UNIT',
    legal_address: '42 Lenina St., Moscow, Russia',
    legal_name: 'LLC "TobaccoProm"',
    tax_id_number: '7701234567',
    height: '125',
    width: '72',
    length: '25',
    weight: '85',
    storage_conditions: 'Store in a cool, dry place at temperatures between +5°C and +25°C',
    storage_period: '24',
    packaging_material: 'Cardboard, foil',
    packaging_type: 'PACKAGE',
    application: 'Smoking',
    release_form: 'Cigarettes',
    substance: 'Nicotine, tobacco',
    tar_content: '8',
    nicotine: '1',
    alcohol: '0',
    volume: '2',
    description: 'Filtered cigarettes with a smooth taste and classic tobacco aroma.',
    composition: 'Tobacco, glycerin, flavorings, paper',
    code_stat_classifier: 'CA12.00.1',
    article: 'SIG-TBK-MILD-20',
    codes_add: 'RU1234567890',
    category_ved: 'Tobacco products',
    code_ved: '2401106000',
    link_image: 'https://example.com/images/cigarette-pack.jpg',
    country_manufacture: 'Russia',
    gps_code: '100500',
    product_vendor_code: 'TBK00123',
    product_name: 'Tobacco Light',
    product_trademark: 'TobaccoPro',
    gtin: '98765432109875',
    product_group_code: 'TOBACCO',
    quantity: 1,
};

export const xlsxSchema = {
    package_type: 'A',
    legal_address: 'B',
    legal_name: 'C',
    tax_id_number: 'D',
    height: 'E',
    width: 'F',
    length: 'G',
    weight: 'H',
    storage_conditions: 'I',
    storage_period: 'J',
    packaging_material: 'K',
    packaging_type: 'L',
    application: 'M',
    content: 'N',
    release_form: 'O',
    substance: 'P',
    tar_content: 'Q',
    nicotine: 'R',
    alcohol: 'S',
    volume: 'T',
    description: 'U',
    composition: 'V',
    code_stat_classifier: 'W',
    article: 'X',
    codes_add: 'Y',
    category_ved: 'Z',
    code_ved: 'AA',
    link_image: 'AB',
    country_manufacture: 'AC',
    gps_code: 'AD',
    product_vendor_code: 'AE',
    product_name: 'AF',
    product_trademark: 'AG',
    gtin: 'AH',
    product_group_code: 'AI',
    quantity: 'AJ',
};

const tmplMutualColumns = [
    'product_type',
    'gtin',
    'product_category',
    'package_type',
    'product_name',
    'quantity',
    'product_vendor_code',
    'brand_name',
    'gpc_code',
    'hsn_code',
    'composition',
    'description',
    'packaging_type',
    'packaging_material',
    'storage_period',
    'storage_conditions',
    'weight',
    'length',
    'width',
    'height',
    'link_image',
];

const tmplDrinks = [
    ...tmplMutualColumns,
    'volume',
    'drink_carbonation',
    'juice_content',
    'drink_sweetened',
];

const tmplMedications = [
    ...tmplMutualColumns,
    'active_substance',
    'dosage_form',
    'strength',
    'administration_route',
    'sterile',
    'single_use',
    'prescription_type',
];

const tmplAlcohol = [
    ...tmplMutualColumns,
    'volume',
    'alcohol',
    'alcohol_carbonation',
    'alcohol_sugar_content',
    'aging_period_months',
    'alcohol_raw_material',
];

const tmplTobacco = [
    ...tmplMutualColumns,
    'nicotine',
    'tar_content',
    'tobacco_flavor',
    'capsule_flavor',
];

const tmplVeterinary = [
    ...tmplMutualColumns,
    'active_substance',
    'dosage_form',
    'strength',
    'administration_route',
    'sterile',
    'single_use',
    'prescription_type',
    'target_species',
];

const tmplCoffee = [
    ...tmplMutualColumns,
    'coffee_product_form',
    'caffeine_content',
    'decaffeinated',
    'coffee_flavored',
    'coffee_organic',
    'coffee_net_weight',
    'coffee_raw_material',
    'coffee_processing_type',
    'coffee_concentration',
];

export const getTemplate = (file_type: string) => {
    switch (file_type) {
        case 'DRINKS':
            return tmplDrinks;
        case 'MEDICATIONS':
            return tmplMedications;
        case 'ALCOHOL':
            return tmplAlcohol;
        case 'TOBACCO':
            return tmplTobacco;
        case 'VETERINARY':
            return tmplVeterinary;
        case 'COFFEE':
            return tmplCoffee;
        default:
            return tmplMutualColumns;
    }
};
